<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>平台往来明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">平台往来明细</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="资金流向">
                  <el-select
                    clearable
                    v-model="ruleForm.type1"
                    placeholder="请选择资金流向"
                    style="margin-right: auto"
                  >
                    <el-option label="收入" value="0"></el-option>
                    <el-option label="支出" value="1"></el-option>
                    <el-option label="挂账" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="资金类型">
                  <el-select
                    clearable
                    v-model="ruleForm.type2"
                    placeholder="请选择资金类型"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in typeList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务类型">
                  <el-select
                    clearable
                    v-model="ruleForm.type3"
                    placeholder="请选择业务类型"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in typeList1"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="账单状态">
                  <el-select
                    clearable
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in statusList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户类型">
                  <el-select
                    clearable
                    v-model="ruleForm.usertype"
                    placeholder="请选择关联人类型"
                    style="margin-right: auto"
                  >
                    <el-option label="客户" value="1"></el-option>
                    <el-option label="保安-临勤" value="2"></el-option>
                    <el-option label="保安公司" value="3"></el-option>
                    <el-option label="平台" value="99"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    @input="isUserType"
                    :value="ruleForm.username"
                    placeholder="请输入用户姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    :value="ruleForm.userphone"
                    @input="isUserType1"
                    placeholder="请输入用户手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="关联交易号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.num"
                    placeholder="请输入关联交易号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="关联人类型">
                  <el-select
                    clearable
                    v-model="ruleForm.type"
                    placeholder="请选择关联人类型"
                    style="margin-right: auto"
                  >
                    <el-option label="客户" value="1"></el-option>
                    <el-option label="保安-临勤" value="2"></el-option>
                    <el-option label="平台" value="99"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="关联人姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    :value="ruleForm.name"
                    @input="isType"
                    placeholder="请输入关联人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="关联人手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    :value="ruleForm.phone"
                    @input="isType1"
                    placeholder="请输入关联人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="时间类型">
                  <el-select
                    clearable
                    v-model="ruleForm.timetype"
                    placeholder="请选择时间类型"
                    style="margin-right: auto"
                  >
                    <el-option label="创建时间" value="0"></el-option>
                    <el-option label="支付时间" value="1"></el-option>
                    <el-option label="操作时间" value="2"></el-option>
                    <el-option label="到账时间" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div style="display: flex; align-items: center">
                  <el-date-picker
                    v-model="ruleForm.time"
                    type="datetime"
                    placeholder="选择开始时间"
                    align="right"
                    @change="timeSelect"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                  <div style="margin: 0 5px">-</div>
                  <el-date-picker
                    v-model="ruleForm.time1"
                    type="datetime"
                    placeholder="选择结束时间"
                    align="right"
                    @change="timeSelect1"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="6">
                <el-form-item label="第三方流水号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.thirdPaymentOrder"
                    placeholder="请输入第三方流水号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付方式">
                  <el-select
                    v-model="ruleForm.type4"
                    placeholder="请选择支付方式"
                    multiple
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in payTypeList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="账单编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.billDetailNo"
                    placeholder="请输入账单编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item style="margin-top: 10px">
                  <el-button type="primary" @click="search()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                  <el-button type="primary" @click="exportList()" class="btn"
                    >excel导出</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <TableScrollSlider :table-ref="$refs.multipleTable" />
      <div class="pageTab">
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="billDetailNo"
            label="账单编号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="changeToName" label="资金流向" align="center">
          </el-table-column>
          <el-table-column label="资金类型" align="center">
            <template slot-scope="scope"> {{ scope.row.changeName }}</template>
          </el-table-column>
          <el-table-column label="业务类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.businessTypeName }}</template
            >
          </el-table-column>
          <el-table-column
            prop="channelTypeName"
            label="支付方式"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="memberTypeName"
            label="用户类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="memberName" label="用户姓名" align="center">
          </el-table-column>
          <el-table-column
            prop="targetTypeName"
            label="关联人类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="targetName" label="关联人姓名" align="center">
          </el-table-column>
          <el-table-column
            prop="thirdPaymentOrder"
            label="第三方交易流水号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column label="平台关联交易号" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.paymentOrder }}</template
            >
          </el-table-column>
          <el-table-column label="任务编号" align="center" width="150">
            <template slot-scope="scope"> {{ scope.row.jobNo }}</template>
          </el-table-column>
          <el-table-column label="金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.changeAmount | moneyFormat }}</template
            >
          </el-table-column>
          <el-table-column label="税费(元)" align="center">
            <template slot-scope="scope"> {{ scope.row.taxAmount }}</template>
          </el-table-column>
          <el-table-column label="费率" align="center">
            <template slot-scope="scope"> {{ scope.row.rate }}</template>
          </el-table-column>
          <el-table-column label="手续费" align="center">
            <template slot-scope="scope">
              {{ scope.row.commissionAmount }}</template
            >
          </el-table-column>
          <el-table-column label="到账金额" align="center">
            <template slot-scope="scope">
              {{ scope.row.practicalAmount }}</template
            >
          </el-table-column>
          <el-table-column label="到账时间" align="center">
            <template slot-scope="scope"> {{ scope.row.changesAt }}</template>
          </el-table-column>
          <el-table-column label="提现银行名称" align="center">
            <template slot-scope="scope">
              {{ scope.row.bankFullName }}</template
            >
          </el-table-column>
          <el-table-column label="提现银行卡号" align="center">
            <template slot-scope="scope"> {{ scope.row.accountNo }}</template>
          </el-table-column>
          <el-table-column label="绑定手机号" align="center">
            <template slot-scope="scope"> {{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="支付时间" align="center" width="180">
            <template slot-scope="scope"> {{ scope.row.paymentAt }}</template>
          </el-table-column>
          <el-table-column prop="userName" label="操作人" align="center">
          </el-table-column>
          <el-table-column
            prop="userOperateTime"
            label="操作时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span
                :class="[
                  scope.row.status == 0
                    ? 'blueColor'
                    : scope.row.status == 2 ||
                      scope.row.status == 5 ||
                      scope.row.status == 6
                    ? 'redColor'
                    : 'greenColor',
                ]"
                >{{ scope.row.statusName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope"> {{ scope.row.memo }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="disAround" v-if="scope.row.status != 3">
                  <div class="operateBtn" @click="Invoicing(scope.row)"></div>
                </div>
              </template>
            </el-table-column> -->
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      ruleForm: {
        time: "",
        time1: "",
        name: "",
        phone: "",
        type: "",
        type1: "",
        type2: "",
        type3: "",
        type4: [],
        jobNo: "",
        num: "",
        timetype: "",
        usertype: "",
        username: "",
        userphone: "",
        thirdPaymentOrder: "",
        status: "",
        billDetailNo: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
      typeList: [],
      pageInfo: {},
      payTypeList: [
        { propDesc: "钱包", propValue: 0 },
        { propDesc: "对公转账", propValue: 1 },
        { propDesc: "银行卡", propValue: 2 },
        { propDesc: "支付宝", propValue: 3 },
        { propDesc: "微信", propValue: 4 },
      ],
      typeList1: [],
      statusList: [],
    };
  },
  mounted() {
    this.getType();
    this.getType1();
    this.getStatus();
    this.getList();
  },
  methods: {
    isUserType(val) {
      if (this.ruleForm.usertype == "") {
        this.$message({
          message: "请选择用户类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.username = val;
      }
    },
    isUserType1(val) {
      if (this.ruleForm.usertype == "") {
        this.$message({
          message: "请选择用户类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.userphone = val;
      }
    },
    isType(val) {
      if (this.ruleForm.type == "") {
        this.$message({
          message: "请选择关联人类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.name = val;
      }
    },
    isType1(val) {
      if (this.ruleForm.type == "") {
        this.$message({
          message: "请选择关联人类型",
          type: "warning",
        });
        return;
      } else {
        this.ruleForm.phone = val;
      }
    },
    timeSelect(val) {
      if (this.ruleForm.timetype == "") {
        this.$message({
          message: "请选择时间类型",
          type: "warning",
        });
        this.ruleForm.time = "";
        return;
      } else {
        this.ruleForm.time = val;
      }
    },
    timeSelect1(val) {
      if (this.ruleForm.timetype == "") {
        this.$message({
          message: "请选择时间类型",
          type: "warning",
        });
        this.ruleForm.time1 = "";
        return;
      } else {
        this.ruleForm.time1 = val;
      }
    },
    search() {
      if (this.ruleForm.timetype != "") {
        if (this.ruleForm.time == "" && this.ruleForm.time1 == "") {
          this.$message({
            message: "请选择时间",
            type: "warning",
          });
        }
      }
      this.page = 1;
      this.getList();
    },
    getType() {
      let param = {
        key: "billDetailChangeTypeByPlatform",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.typeList = data;
        })
        .catch()
        .finally();
    },
    getType1() {
      let param = {
        key: "billDetailBusinessTypeByPlatform",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.typeList1 = data;
        })
        .catch()
        .finally();
    },
    getStatus() {
      let param = {
        key: "billDetailStatusByPlatform",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.statusList = data;
        })
        .catch()
        .finally();
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.time = "";
      this.ruleForm.time1 = "";
      this.ruleForm.name = "";
      this.ruleForm.phone = "";
      this.ruleForm.type = "";
      this.ruleForm.type1 = "";
      this.ruleForm.type2 = "";
      this.ruleForm.type3 = "";
      this.ruleForm.type4 = [];
      this.ruleForm.jobNo = "";
      this.ruleForm.num = "";
      this.ruleForm.timetype = "";
      this.ruleForm.usertype = "";
      this.ruleForm.username = "";
      this.ruleForm.userphone = "";
      this.ruleForm.thirdPaymentOrder = "";
      this.ruleForm.status = "";
      this.ruleForm.billDetailNo = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        timeType: this.ruleForm.timetype,
        page: this.page,
        pageSize: this.pageSize,
        businessType: this.ruleForm.type3,
        changeTo: this.ruleForm.type1,
        changeType: this.ruleForm.type2,
        channelType: this.ruleForm.type4,
        endTime: this.ruleForm.time1,
        jobNo: this.ruleForm.jobNo,
        memberName: this.ruleForm.username,
        memberPhone: this.ruleForm.userphone,
        memberType: this.ruleForm.usertype,
        paymentOrder: this.ruleForm.num,
        startTime: this.ruleForm.time,
        status: this.ruleForm.status,
        thirdPaymentOrder: this.ruleForm.thirdPaymentOrder,
        targetName: this.ruleForm.name,
        targetPhone: this.ruleForm.phone,
        targetType: this.ruleForm.type,
        billDetailNo: this.ruleForm.billDetailNo,
      };
      this.$axios
        .post(`/admapi/platformwallet/billlist`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
      this.$axios
        .post(`/admapi/platformwallet/statistic`, param)
        .then(({ data }) => {
          this.pageInfo = data;
        })
        .catch()
        .finally();
    },
    exportList() {
      this.$confirm("是否导出数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            page: this.page,
            pageSize: this.pageSize,
            businessType: this.ruleForm.type3,
            changeTo: this.ruleForm.type1,
            changeType: this.ruleForm.type2,
            channelType: this.ruleForm.type4,
            endTime: this.ruleForm.time1,
            jobNo: this.ruleForm.jobNo,
            memberName: this.ruleForm.username,
            memberPhone: this.ruleForm.userphone,
            memberType: this.ruleForm.usertype,
            paymentOrder: this.ruleForm.num,
            startTime: this.ruleForm.time,
            status: this.ruleForm.status,
            thirdPaymentOrder: this.ruleForm.thirdPaymentOrder,
            timeType: this.ruleForm.timetype,
            targetName: this.ruleForm.name,
            targetPhone: this.ruleForm.phone,
            targetType: this.ruleForm.type,
          };
          let arr = [];
          if (this.multipleTable.length != 0) {
            for (var i = 0; i < this.multipleTable.length; i++) {
              arr.push(this.multipleTable[i].id);
            }
          }
          param.ids = arr;
          this.$axios
            .post("/admapi/platformwallet/billexport", param, {
              responseType: "blob",
            })
            .then((data) => {
              console.log(data);
              let val = new Blob([data.data], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              let header = decodeURI(data.headers["content-disposition"]);
              console.log(header);
              let index = header.indexOf("''");
              let fileName = header.substring(index + 2, header.length);
              const url = window.URL.createObjectURL(val);
              const link = document.createElement("a");
              link.download = fileName; // 设置a标签的下载属性
              link.style.display = "none";
              link.href = url;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
              document.body.removeChild(link);
            })
            .catch()
            .finally();
          // );
        })
        .catch(() => {});
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
